 
<!-- <app-navbar-style-one></app-navbar-style-one> -->
<!-- Start Page Title Area -->
<div class="page-title-area md:py-5"  style="background-image: url('assets/img/page-title/page-title1.jpg'); padding-top: 0px;
padding-bottom: 0px;">

<div class="spinner-overlay" *ngIf="isLoading">
    <div class="spinner"></div>
  </div>
    <!-- Start Login & Register Modal -->
   

    <div class="modal-content">
        <button class="close-btn" (click)="closePopup()">×</button>
        
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <button class="nav-link" (click)="switchTab($event, 'tab1')"
                    [ngClass]="{'active': currentTab === 'tab1'}">
                    Login
                </button>
            </li>
            <li class="nav-item">
                <button class="nav-link" (click)="switchTab($event, 'tab2')"
                    [ngClass]="{'active': currentTab === 'tab2'}">
                    Register
                </button>
            </li>
        </ul>
        <div class="tab-content">
            <div class="tab-pane fade show active" *ngIf="currentTab === 'tab1'">
                <div class="vesax-login">
                  
                    <span class="sub-title"><span>login with</span></span>
                    <form>
                        <div class="form-group">
                            <input type="text" [(ngModel)]="userAccount.UserNameEmail" name="userNameEmail" placeholder="Username or Email" class="form-control" (ngModelChange)="disableLoginBtn()">
                                <span class="text-danger" *ngIf="errorUserNameEmail.isError">{{ errorUserNameEmail.errorMessage }}</span>
                            <!-- <input type="text" placeholder="Username or Email" class="form-control" [(ngModel)]="userAccount.User_Name" name="username"  > -->
                        </div>
                        <div class="form-group">
                            <input type="password" placeholder="Password" class="form-control"
                                [(ngModel)]="userAccount.LoginPassword" name="loginPassword" (ngModelChange)="disableLoginBtn()"
                                >
                                <span class="text-danger" *ngIf="errorLoginPassword.isError">{{ errorLoginPassword.errorMessage }}</span>
                            <!-- <input type="password" placeholder="Password" class="form-control" [(ngModel)]="userAccount.PASSWORD" name="password" type="password"> -->
                        </div>
                        <button type="submit" (click)="Login()">Login Now</button>
                    </form>
                    <span class="dont-account">Don't have an account? <a (click)="switchTab($event, 'tab2')">Register Now</a></span>
                    <!-- <div class="other-links">
                        <div class="text pb-2">Or login with</div>
                        <a href="#"><i class="bi bi-facebook"></i></a><a href="#"><i class="bi bi-google"></i></a><a href="#"><i class="bi bi-linkedin"></i></a>
                    </div> -->
                </div>
            </div>
            <div class="tab-pane fade show active" *ngIf="currentTab === 'tab2'">
                <div class="vesax-register">
                   
                    <span class="sub-title"><span>Register with</span></span>
                    <form>
                        <div class="form-group">
                            <!-- <input type="text" placeholder="Username" class="form-control"> -->
                            <input type="text" [(ngModel)]="userAccount.User_Name" name="username" placeholder="Username" class="form-control" (ngModelChange)="disableRegisterBtn()">
                            <span class="text-danger" *ngIf="errorRegisterUserName.isError">{{ errorRegisterUserName.errorMessage }}</span>
                            
                        </div>
                        <div class="form-group">
                            <!-- <input type="email" placeholder="Email" class="form-control"> -->
                            <input type="email" placeholder="Email" class="form-control" name="usernameemail" [(ngModel)]="userAccount.EMAIL_ADDRESS" (ngModelChange)="disableRegisterBtn()">
                                <span class="text-danger" *ngIf="errorEmail.isError">{{ errorEmail.errorMessage }}</span>
                        </div>
                        <div class="form-group">
                            <!-- <input type="password" placeholder="Password" class="form-control"> -->
                            <input type="password" placeholder="Password" class="form-control" name="password" [(ngModel)]="userAccount.PASSWORD" (ngModelChange)="disableRegisterBtn()">
                                <span class="text-danger" *ngIf="errorPassword.isError">{{ errorPassword.errorMessage }}</span>
                        </div>
                        <div class="form-group">
                            <!-- <input type="password" placeholder="Confirm Password" class="form-control"> -->
                            <input type="confirmpassword" placeholder="Confirm Password"  name="confirmpassword"class="form-control" [(ngModel)]="userAccount.CONFIRM_PASSWORD" (ngModelChange)="disableRegisterBtn()">
                            <span class="text-danger" *ngIf="errorConfirmPassword.isError">{{ errorConfirmPassword.errorMessage }}</span>
                        </div>
                        <button type="submit" (click)="registerNow()" [disabled]="isDisableRegisterBtn">Register Now</button>
                        
                    </form>
                    <span class="already-account">Already have an account? <a (click)="switchTab($event, 'tab1')">Login Now</a></span>
                    <!-- <div class="register-with-account">
                        <span>Or Register with</span>
                        <ul>
                            <li><a href="#" class="facebook"><i class='bx bxl-facebook'></i> Facebook</a></li>
                            <li><a href="#" class="twitter"><i class='bx bxl-twitter'></i> Twitter</a></li>
                        </ul>
                    </div> -->
                    <!-- <div class="other-links">
                        <div class="text pb-2">Or login with</div>
                        <a href="#"><i class="bi bi-facebook"></i></a><a href="#"><i class="bi bi-google"></i></a><a href="#"><i class="bi bi-linkedin"></i></a>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
<!-- End Login & Register Modal -->
</div>
 